import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/solution/crm-new/why_choose_crm.webp";

function Whychoosewebapp() {
  return (
    <section
      className="why_choose_webapp p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol as Your <span>CRM Development Company</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              At TekRevol, we pride ourselves on our proven track record in CRM
              development, showcasing our credibility and extensive experience
              in delivering tailored solutions. Our team of experts possesses
              deep industry knowledge and technical prowess, ensuring that every
              CRM system we create meets the highest standards of functionality
              and user satisfaction. With a commitment to innovation and
              excellence, we strive to empower businesses with efficient and
              effective CRM systems.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="why-choose-web-main">
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">01</div>
                  <div className="why-choose-content">
                    <h5>Extensive Industry Experience</h5>
                    <p>
                      Our years of experience across various industries ensure
                      customized CRM solutions that fit your unique needs.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">02</div>
                  <div className="why-choose-content">
                    <h5>Skilled & Knowledgeable Team</h5>
                    <p>
                      Our team comprises highly skilled professionals with deep
                      technical expertise in CRM development.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">03</div>
                  <div className="why-choose-content">
                    <h5>Proven Track Record</h5>
                    <p>
                      We have a history of successfully delivering robust and
                      scalable CRM systems to satisfied clients.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">04</div>
                  <div className="why-choose-content">
                    <h5>Client-Centric Approach</h5>
                    <p>
                      We focus on understanding and meeting the specific
                      requirements and goals of each client.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">05</div>
                  <div className="why-choose-content">
                    <h5>Customized Integrations</h5>
                    <p>
                      Our solutions seamlessly integrate with your existing
                      systems for a smooth and efficient workflow.
                    </p>
                  </div>
                </div>
              </div>
              <div className="why-choose-item">
                <div className="why-choose-box">
                  <div className="num">06</div>
                  <div className="why-choose-content">
                    <h5>Commitment to Quality</h5>
                    <p>
                      We adhere to the highest standards of quality in every
                      aspect of our CRM development process.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosewebapp;
